// extracted by mini-css-extract-plugin
module.exports = {"ReportTitle":"Page_ReportTitle__jq2Yb","MainWrapper":"Page_MainWrapper__FdY0L","CompleteButton":"Page_CompleteButton__1qLnD"};